import { TENANT_ID } from "../config";

export const ALLOWED_ATIVIDADES_NR = new Set([
  0, 1, 2, 3, 4, 6, 8, 10, 14, 15, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
  39, 40, 41, 42, 43, 44, 45, 46, 47, 51, 52, 54, 57, 72, 73, 74, 75, 76, 77, 81,
  82, 84, 85, 88, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
  106, 107, 108, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 136, 137, 138, 139, 140,
  141, 142, 143, 144, 145, 146, 149, 150, 151, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164,
  165, 166, 167, 168, 169, 170, 171, 172, 173, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185,
  188, 189, 190, 191, 192, 193, 194, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209,
  210, 211, 212, 213, 214, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 229, 230, 231, 232,
  233, 234, 235, 236, 237, 238, 239, 240, 241, 245, 246, 247, 248, 251, 252, 253, 254, 259, 261, 263,
  264, 265, 267, 269, 271, 274, 275, 276, 278, 279, 280, 281, 282, 283, 284, 286, 289, 290, 291, 292,
  297, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318,
  319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338,
  339, 340, 343, 345, 348, 349, 350, 351, 352, 353, 356, 357, 358, 359, 360, 362, 363, 366, 370, 371,
  372, 373, 374, 375, 376, 377, 378, 380, 381, 383, 399, 400, 401, 402, 403, 404, 405, 406,
]);

export function normalizeTenantId(tenantId) {
  if (!tenantId || typeof tenantId !== "string") return null;
  const normalized = tenantId
    .trim()
    .toLowerCase()
    .replace(/[-_\s]/g, "");

  switch (normalized) {
    case "novarussas":
    case "nr":
      return "NR";
    case "novooriente":
    case "no":
      return "NO";
    case "poranga":
    case "prg":
      return "PRG";
    case "testes":
      return "TESTES";
    default:
      return null;
  }
}

export function temRestricaoDeAtividades(tenantId = TENANT_ID) {
  return normalizeTenantId(tenantId) === "NR";
}

export function isAtividadePermitidaNoTenant(atividadeValue, tenantId = TENANT_ID) {
  if (!temRestricaoDeAtividades(tenantId)) return true;
  return ALLOWED_ATIVIDADES_NR.has(Number(atividadeValue));
}

export function filtrarAtividadePorGrupoParaTenant(
  atividadePorGrupo,
  tenantId = TENANT_ID,
) {
  if (!temRestricaoDeAtividades(tenantId)) {
    return atividadePorGrupo;
  }

  const filtrado = {};
  for (const [grupo, atividades] of Object.entries(atividadePorGrupo)) {
    const permitidas = (atividades ?? []).filter((a) =>
      ALLOWED_ATIVIDADES_NR.has(Number(a.value)),
    );
    if (permitidas.length > 0) {
      filtrado[grupo] = permitidas;
    }
  }
  return filtrado;
}

export function filtrarGruposAtividadeParaTenant(
  grupoOptions,
  atividadePorGrupoFiltrado,
) {
  const gruposComAtividade = new Set(
    Object.keys(atividadePorGrupoFiltrado).map((k) => Number(k)),
  );
  return grupoOptions.filter((g) => gruposComAtividade.has(Number(g.value)));
}
